import { INewProductInCart } from "src/_cores/_interfaces/product.interface";

export class CartHelper {
    public static getUniqId(product: INewProductInCart) {
        const _options = product.options.map(_ => ({
            id: _.id,
            value: _.value
        }))
        return `${product.id}_${product.price}_${product.discount}_${product.priceType}_${JSON.stringify(_options)}`;
    }

    // Same rule as the backend's CreateOrder: a voucher applies when it targets the product, its brand or its shop
    public static isVoucherApplicable(voucher: any, product: INewProductInCart) {
        return voucher.productIds?.includes(product.id)
            || voucher.brandIds?.includes(product.brandId)
            || voucher.shopIds?.includes(product.shopId);
    }
}